module.exports = __webpack_public_path__ + "img/t1-salmon.d6417231.png";